import React, { useState, useEffect } from 'react'
import Card from 'react-bootstrap/Card';
import {
    FaCamera,
    FaTags
} from 'react-icons/fa';
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";
import Avatar from './Avatar';
import BusinessEditModal from './BusinessEditModal';
import axios from '../../utils/axios';
import { CiImageOff } from "react-icons/ci";
import AdvertisementModal from "../../modal/AdvertisementModal";
import UpdateAdvertisementModal from "../../modal/UpdateAdvertisementModal";
import { Button } from 'react-bootstrap';
import imageUrl from '../../utils/imageUrl';

function BusinessDetails() {
    const [business, setBusiness] = useState({});
    const [isLoaded, setIsLoaded] = useState(false);
    const [payment, setPayment] = useState(0);
    const [advertisement, setAdvertisement] = useState('');
    const [adId, setAdId] = useState('');
    const [isAdUpdated, setIsAdUpdated] = useState(false);
    const fetchData = async (bData) => {
        await axios.get('business/getBusinessViewFees/' + bData._id).then((response) => {
            let views = response.data.Data;
            let payment = 0;
            views.map((view) => {
                payment = payment + view.BusinessViewFees;
                setPayment(payment);
            });
            setIsLoaded(!isLoaded);
        }).catch((error) => console.log(error));
        console.log(payment);
    }
    const loadData = async () => {
        var bData = window.sessionStorage.getItem("business");
        bData = JSON.parse(bData);
        setBusiness(bData);
        console.log(bData);
        await fetchData(bData);
    }
    const businessDetailsUpdate = (bData) => {
        setBusiness(bData);
    }

    // const viewLogsHandler = () => {
    //     let id = business._id;
    //     var baseURL = axios.defaults.baseURL;
    //     window.open(`${baseURL}uploads/businessViewlogs` + id + '.txt', '_blank');
    // }

    useEffect(() => {
        loadData();
    }, []);


    useEffect(() => {
        const fetchData = () => {
            axios.get('ad/getAllAd').then((data) => {
                if (data.data.Data !== undefined) {
                    const tempData = data.data.Data.filter((item) => {
                        if (item.SponsorCode === business.advertisementCode)
                            return true;
                        return false;
                    });
                    // console.log(data.data.Data);
                    // console.log(tempData);
                    if (tempData.length > 0) {
                        setAdvertisement(tempData[tempData.length - 1].Image);
                        setAdId(tempData[tempData.length - 1]._id);
                    }
                }
            }).catch((error) => console.log(error));
        }
        fetchData();
    }, [isLoaded, isAdUpdated]);

    if (!isLoaded) {
        return (
            <>
            </>
        )
    }
    return (
        <Card body>
            <section className='business-details'>
                <div className='container'>
                    <Row>
                        <div className='col-md-6'>
                            <h1 className='mb-0 h3 fw-bold'>Business Details</h1>
                        </div>
                        <div className='col-md-6 text-end'>
                            <BusinessEditModal businessData={business} handler={businessDetailsUpdate} />

                        </div>
                    </Row>
                    <hr></hr>
                    <Row>
                        <div className='col-md-4'>
                            <Avatar img={business.Image} businessId={business._id} />
                        </div>
                        <Col md='8'>
                            <Row>
                                <div style={{ margin: '20px' }}>
                                    <p><b>Business Name:</b></p>
                                    <b style={{ fontSize: '1.8rem' }}><h3>{business.Name ?? ''}</h3></b>
                                </div>
                            </Row>
                            <hr></hr>
                            <Row>
                                <Col md='6'>
                                    
                                    <div className="text-center" style={{ margin: '20px' }}>
                                <small><b>Business Views:</b></small>
                                <div className="text-center" style={{ margin: '20px' }}>
                                        <div className="counters mx-auto" style={{width: 'fit-content'}}>
                                        <b >{business.Views}</b>
                                        </div>
                                </div>
                            </div>
                                </Col>
                                <Col md='6'>
                                    <div className="text-center" style={{ margin: '20px' }}>
                                        <small><b>Outstanding Payment:</b></small>
                                        <div className="text-center" style={{ margin: '20px'}}>
                                                <div className="counters mx-auto" style={{width: 'fit-content' , color: 'red'}}>
                                        <b >${payment}</b>
                                        </div>
                                        </div>
                                    </div>
                                </Col>
                            </Row>

                            <Row style={{ marginTop: '10px', marginBottom: '10px' }}>
                                <Col md='6' className='text-center'>
                                    {/* <Button className='w-50' onClick={viewLogsHandler}>Views Log</Button> */}
                                </Col>
                                <Col md='6' className='text-center'>
                                    <Button className='w-50'>Pay Now</Button>
                                </Col>
                            </Row>
                        </Col>
                    </Row>
                    <Row>
                        <Col md='4'>
                        <div className="text-center" style={{ margin: '20px' }}>
                                        <small><b>Sponsor Code Redemptions:</b></small>
                                        <div className="text-center" style={{ margin: '20px' }}>
                                              <div className="counters mx-auto" style={{width: 'fit-content'}}>
                                        <b >{business.CodeRedemptions}</b>
                                        </div>
                                            
                                        </div>
                                    </div>
                        </Col>
                        <Col md='4'>
                            <div className="text-center" style={{ margin: '20px' }}>
                                <small><b>Website Views:</b></small>
                                <div className="text-center" style={{ margin: '20px' }}>
                                        <div className="counters mx-auto" style={{width: 'fit-content'}}>
                                        <b >{business.WebsiteViews}</b>
                                        </div>
                                </div>
                                
                            </div>
                        </Col>
                        <Col md='4'>
                            <div className="text-center" style={{ margin: '20px' }}>
                                <small><b>Business Calls:</b></small>
                                    <div className="text-center" style={{ margin: '20px' }}>
                                        <div className="counters mx-auto" style={{width: 'fit-content'}}>
                                        <b >{business.Calls}</b>
                                        </div>
                                </div>
                            </div>
                        </Col>
                    </Row>
                    <hr></hr>
                    <Row>
                        <p className="p" style={{ fontSize: '1.4rem' }}>
                            <b><u>Business Address</u></b>
                        </p>
                    </Row>
                    <Row>
                        <Col md='4'>
                            <p className="p" style={{ fontSize: '1rem' }}>
                                <b>Street Address:</b> <br></br>{business.Street}
                            </p>
                        </Col>
                        <Col md='4'>
                            <p className="p" style={{ fontSize: '1rem' }}>
                                <b>City:</b> <br></br>{business.City}
                            </p>
                        </Col>
                        <Col md='4'>
                            <p className="p" style={{ fontSize: '1rem' }}>
                                <b>State:</b> <br></br>{business.State}
                            </p>
                        </Col>
                    </Row>
                    <Row>
                        <Col md='4'>
                            <p className="p" style={{ fontSize: '1rem' }}>
                                <b>ZipCode:</b> <br></br>{business.Zipcode}
                            </p>
                        </Col>
                        <Col md='4'>
                            <p className="p" style={{ fontSize: '1rem' }}>
                                <b>Country:</b> <br></br>{business.Country}
                            </p>
                        </Col>
                    </Row>
                    <hr></hr>
                    <Row>
                        <p className="p" style={{ fontSize: '1.4rem' }}>
                            <b><u>Contact Info</u></b>
                        </p>
                    </Row>
                    <Row>
                        <Col md='4'>
                            <p className="p" style={{ fontSize: '1rem' }}>
                                <b>Email:</b><br></br> {business.Email}
                            </p>
                        </Col>
                        <Col md='4'>
                            <p className="p" style={{ fontSize: '1rem' }}>
                                <b>Website:</b> <br></br>{business.Website}
                            </p>
                        </Col>
                        <Col md='4'>
                            <p className="p" style={{ fontSize: '1rem' }}>
                                <b>Phone:</b> <br></br>{business.Phone}
                            </p>
                        </Col>
                    </Row>
                    <hr></hr>
                    <Row>
                        <Col md='4'>
                            <p className="p" style={{ fontSize: '1.4rem' }}>
                                <b><u>Categories</u></b>
                            </p>
                        </Col>

                        <Col md='8'>
                            <p className="p" style={{ fontSize: '1rem' }}>
                                <b>Your Categories:</b> <br></br>
                                {
                                    business.Categories.length != 0 ?
                                        business.Categories.toString().split(",").map((category, index) => {
                                            return category == '' ? <span className="badge p-2 bg-danger text-capitalize me-2 mt-2">No Categories</span>  :<span key={index}
                                                className="badge p-2 bg-danger text-capitalize me-2 mt-2">{category}</span>
                                        })
                                        :
                                        <span className="badge p-2 bg-danger text-capitalize me-2 mt-2">No Categories</span>
                                }
                            </p>
                        </Col>
                    </Row>
                    <hr></hr>
                    <Row>
                        <p className="p" style={{ fontSize: '1.4rem' }}>
                            <b><u>Your Advertisement</u></b>
                        </p>
                    </Row>
                    <Row>
                        <Col md='8'>
                            <div>
                                {(advertisement !== "") ?
                                    <img src={`${imageUrl}${advertisement}`} className="w-300" style={{
                                        height: '120px',
                                        objectFit: 'cover'
                                    }} />
                                    :
                                    <>
                                        <CiImageOff style={{
                                            fontSize: '10rem',
                                            marginTop: "10px",
                                            marginBottom: "20px",
                                            marginLeft: "20px"
                                        }} />
                                        <p style={{ color: 'red' }}>You have not added any Advertisement.</p>
                                    </>
                                }
                            </div>
                        </Col>
                        <Col md='4'>
                            {
                                adId !== '' && adId !== null && adId !== undefined ?
                                    <UpdateAdvertisementModal adId={adId} handler={setIsAdUpdated} />
                                    :
                                    <AdvertisementModal sponsorCode={business.advertisementCode} />
                            }
                        </Col>
                    </Row>
                    <Row>
                        <div>
                            <p></p>
                            <p></p>
                            <p></p>
                        </div>
                    </Row>
                </div>
            </section>
        </Card>

    )
}

export default BusinessDetails;
